import React, { PureComponent } from 'react'
import Drawer from './drawer'
import OpacityHelper from 'aria-viewer/tour/components/opacityHelper'
import { connect } from 'react-redux'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'

import { hideDrawer, openDrawer } from './drawerMenuActions'
import colors from 'aria-viewer/tour/constants/style/colors'
import styleguide from 'aria-viewer/tour/constants/styleGuide'

const noop = _ => null

class DrawerFader extends PureComponent {
    static defaultProps = {
        autoHide: true,
        hideOnOverlayClick: false,
    }

    constructor(props) {
        super(props)

        this.handleOnMouseEnter = this.handleOnMouseEnter.bind(this)
        this.handleOnClick = this.handleOnClick.bind(this)

        this.state = { active: false }
    }

    init(props, nextProps) {
        clearTimeout(this.timeout)
        if (nextProps.drawer === nextProps.name) {
            this.timeout = setTimeout(() => {
                const { onOpen } = nextProps

                onOpen && onOpen()

                requestAnimationFrame(() =>
                    this.setState({
                        active: true,
                    })
                )
            }, Number.parseInt(styleguide.delay.normal))
        } else {
            requestAnimationFrame(() =>
                this.setState({
                    active: false,
                })
            )
        }
        if (props.open !== nextProps.open) {
            if (nextProps.open) {
                nextProps.openDrawer(nextProps.name)
            }
        }
    }
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }
    componentWillMount() {
        this.init({}, this.props)
    }
    componentWillReceiveProps(nextProps) {
        this.init(this.props, nextProps)
    }

    closeDrawer(hideDrawerOverride) {
        if (hideDrawerOverride && (this.state.active && !this.props.open)) {
            this.props.hideDrawer()
        }
    }

    handleOnMouseEnter() {
        const { onClose } = this.props

        onClose && onClose()

        requestAnimationFrame(() => this.closeDrawer(this.props.autoHide))
    }

    handleOnClick(e) {
        const { onClick, onClose } = this.props

        onClose && onClose()

        if (onClick) return onClick(e)

        this.closeDrawer(this.props.hideOnOverlayClick)
    }

    render() {
        const open = this.props.drawer === this.props.name || this.props.open
        const backgroundOpacity = this.props.backgroundOpacity || colors.dark_blue_transparent_9
        return (
            <div onClick={this.props.onClick}>
                <OpacityHelper
                    onMouseEnter={this.handleOnMouseEnter}
                    onClick={this.handleOnClick}
                    test={open}
                    style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        background: backgroundOpacity,
                        zIndex: 2000,
                        transform: `translate3d(0, 0, 1px)`,
                        ...this.props.opacityHelperStyle,
                    }}
                >
                    {noop}
                </OpacityHelper>
                <Drawer {...this.props}>{this.props.children}</Drawer>
            </div>
        )
    }
}

DrawerFader.defaultProps = {
    opacityHelperStyle: {},
}

export default connect(
    mapSelectorsToProps(['drawer']),
    {
        hideDrawer,
        openDrawer,
    }
)(DrawerFader)
